module.exports = __webpack_public_path__ + "static/media/AB_P7_11.1376eb01.jpg";